import React from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OperatorContext, useOperators } from "@/components/mobile/operators";
import { OperatorLogo } from "@/components/mobile/OperatorLogo";
import { SimStockPanel } from "@/components/sim/SimStockPanel";
import SellSim from "@/pages/SellSim";
import DealerItaliaMobile from "@/pages/DealerItaliaMobile";
import { ExternalLink } from "lucide-react";

const TABS = [["gestisci", "Operazioni SIM"], ["ordina", "Ordina SIM"], ["pratiche", "Le mie pratiche"]];
const SELL = ["attivazione", "ricarica", "info", "cambio_promo"];

export default function MobileHub() {
  const { opKey } = useParams();
  const { user } = useAuth();
  const ops = useOperators();
  const [params, setParams] = useSearchParams();
  if (opKey === "simamma") return <Navigate to="/app/esim-simamma" replace />;
  if (user?.role === "admin") return <Navigate to={`/app/operatori-mobili?operatore=${opKey}`} replace />;
  if (!ops) return <p className="text-sm text-muted-foreground">Caricamento…</p>;
  const op = ops.find((o) => o.key === opKey && o.kind === "sim");
  if (!op) return <p className="text-sm text-muted-foreground" data-testid="mobile-hub-unavailable">Operatore non disponibile per il tuo account.</p>;
  const f = op.features || {};
  const tabs = TABS.filter(([k]) => k === "pratiche" || (k === "ordina" ? f.ordini !== false : SELL.some((x) => f[x] !== false)));
  const tab = tabs.some(([k]) => k === params.get("tab")) ? params.get("tab") : tabs[0][0];
  return (
    <OperatorContext.Provider value={op}>
      <div className="space-y-6" data-testid={`mobile-hub-${op.key}`}>
        <header className="flex flex-col items-start gap-4 border-b border-border pb-5 sm:flex-row sm:flex-wrap sm:items-center sm:gap-5">
          <div className="flex h-16 items-center rounded-2xl border border-border bg-white px-5 shadow-sm"><OperatorLogo op={op} className="h-10" testid="mobile-hub-logo" /></div>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium tracking-wider uppercase text-muted-foreground">Operatore mobile</p>
            <h1 className="font-head text-3xl font-bold tracking-tight mt-1" data-testid="mobile-hub-title">{op.name}</h1>
          </div>
          {op.website && <a href={op.website} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-sm text-primary hover:underline" data-testid="mobile-hub-website">Sito operatore <ExternalLink className="w-3.5 h-3.5" /></a>}
        </header>
        <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
          <TabsList className="h-auto flex-wrap" data-testid="mobile-hub-tabs">
            {tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`mobile-hub-tab-${k}`}>{l}</TabsTrigger>)}
          </TabsList>
        </Tabs>
        <div key={`${op.key}-${tab}`}>{tab === "gestisci" ? <SellSim embedded /> : tab === "ordina" ? <SimStockPanel /> : <DealerItaliaMobile />}</div>
      </div>
    </OperatorContext.Provider>
  );
}
